module.exports = __webpack_public_path__ + "img/settings.fbbb5ab4.svg";